import { useEffect, useCallback } from 'react';
import { useRecoilValue } from 'recoil';
import useToggle from '~/src/hooks/useToggle';
import { ProjectMenuActions, selectedMenuActionState } from '../../store';
import { useResetProjectMenuDialogs } from './useResetProjectMenuDialogs';

export const useProjectGridEditTagsDialog = () => {
  const menuAction = useRecoilValue(selectedMenuActionState);
  const [isEditTagsDialogOpen, showEditTagsDialog, hideEditTagsDialog] = useToggle();
  const resetProjectMenuDialogs = useResetProjectMenuDialogs();

  useEffect(() => {
    if (menuAction === ProjectMenuActions.EditTags) {
      showEditTagsDialog();
    }
  }, [menuAction]);

  const handleHideEditTagsDialog = useCallback(() => {
    hideEditTagsDialog();
    resetProjectMenuDialogs();
  }, []);

  return { isEditTagsDialogOpen, showEditTagsDialog, hideEditTagsDialog: handleHideEditTagsDialog };
};

export default useProjectGridEditTagsDialog;
